import { RootState } from "../../app/store";
import { SupplementaryComponentInfoProps } from "../../types";

const SupplementaryComponentInfoRenderer = ({
  supplementaryComponentInfo,
  state,
}: {
  supplementaryComponentInfo: SupplementaryComponentInfoProps | null;
  state: RootState;
}) => {
  if (!supplementaryComponentInfo) return null;
  const { show, component } = supplementaryComponentInfo;
  let shouldShow = false;
  if (typeof show === "function") {
    shouldShow = show(state);
  } else if (typeof show === "boolean") {
    shouldShow = show;
  }
  if (shouldShow) {
    return typeof component === "function" ? component() : component;
  }
  return null;
};
export default SupplementaryComponentInfoRenderer;
